import { render, staticRenderFns } from "./PassagePermitDetail.vue?vue&type=template&id=e865e0a0&scoped=true&"
import script from "./PassagePermitDetail.vue?vue&type=script&lang=js&"
export * from "./PassagePermitDetail.vue?vue&type=script&lang=js&"
import style0 from "./PassagePermitDetail.vue?vue&type=style&index=0&id=e865e0a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e865e0a0",
  null
  
)

export default component.exports